package br.com.vvrefeicoes.portal.feature.operacional

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.clickable
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.PrimaryScrollableTabRow
import androidx.compose.material3.Surface
import androidx.compose.material3.Switch
import androidx.compose.material3.Tab
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.di.LocalAppGraph
import br.com.vvrefeicoes.portal.core.di.rememberSessionPermissions
import br.com.vvrefeicoes.portal.core.ui.components.AppBadge
import br.com.vvrefeicoes.portal.core.ui.components.AppBanner
import br.com.vvrefeicoes.portal.core.ui.components.AppButton
import br.com.vvrefeicoes.portal.core.ui.components.AppFooter
import br.com.vvrefeicoes.portal.core.ui.components.AppModalCard
import br.com.vvrefeicoes.portal.core.ui.components.AppTextField
import br.com.vvrefeicoes.portal.core.ui.components.AppToast
import br.com.vvrefeicoes.portal.core.ui.components.EmptyState
import br.com.vvrefeicoes.portal.core.ui.components.PortalButtonVariant
import br.com.vvrefeicoes.portal.core.ui.components.SearchableSelect
import br.com.vvrefeicoes.portal.core.ui.layout.AppScrollColumn
import br.com.vvrefeicoes.portal.core.ui.theme.AppPalette
import br.com.vvrefeicoes.portal.core.ui.theme.AppShapes
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import br.com.vvrefeicoes.portal.core.ui.theme.PortalTheme
import br.com.vvrefeicoes.portal.core.util.MoneyFormatter
import br.com.vvrefeicoes.portal.core.util.MonthCalendar
import br.com.vvrefeicoes.portal.core.util.PdfReport
import br.com.vvrefeicoes.portal.core.util.PdfWriter
import br.com.vvrefeicoes.portal.core.util.PercentFormatter
import br.com.vvrefeicoes.portal.core.util.SystemDateTimeProvider
import br.com.vvrefeicoes.portal.core.util.encodeBase64
import br.com.vvrefeicoes.portal.core.util.isPdfExportSupported
import br.com.vvrefeicoes.portal.core.util.savePdf
import br.com.vvrefeicoes.portal.domain.model.CompanyRef
import br.com.vvrefeicoes.portal.domain.model.EntryRow
import br.com.vvrefeicoes.portal.domain.model.EntryRowLabel
import br.com.vvrefeicoes.portal.domain.model.EntryTableKind
import br.com.vvrefeicoes.portal.domain.model.MonthPeriod
import br.com.vvrefeicoes.portal.domain.model.OperationalEntry
import br.com.vvrefeicoes.portal.domain.model.OperationalEntryEvent
import br.com.vvrefeicoes.portal.domain.model.OperationalEntryEventType
import br.com.vvrefeicoes.portal.domain.model.OperationalEntryKind
import br.com.vvrefeicoes.portal.domain.model.OperationalEntryStatus
import br.com.vvrefeicoes.portal.domain.model.PendingEntryUnit
import br.com.vvrefeicoes.portal.domain.model.PermissionAction
import br.com.vvrefeicoes.portal.domain.model.PermissionKeys
import br.com.vvrefeicoes.portal.domain.model.StaffMovement
import br.com.vvrefeicoes.portal.domain.model.StaffMovementType
import br.com.vvrefeicoes.portal.domain.model.allows
import br.com.vvrefeicoes.portal.feature.shell.LocalGlobalFilters
import com.composables.icons.lucide.ArrowLeft
import com.composables.icons.lucide.Ban
import com.composables.icons.lucide.Bell
import com.composables.icons.lucide.Building
import com.composables.icons.lucide.Check
import com.composables.icons.lucide.ChevronDown
import com.composables.icons.lucide.Eraser
import com.composables.icons.lucide.FileDown
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.Package
import com.composables.icons.lucide.Pencil
import com.composables.icons.lucide.Plus
import com.composables.icons.lucide.Save
import com.composables.icons.lucide.Scale
import com.composables.icons.lucide.Send
import com.composables.icons.lucide.TrendingDown
import com.composables.icons.lucide.TrendingUp
import kotlinx.coroutines.delay
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.back
import portalvv.shared.generated.resources.operational_action_approve
import portalvv.shared.generated.resources.operational_action_clear
import portalvv.shared.generated.resources.operational_action_edit
import portalvv.shared.generated.resources.operational_action_export_pdf
import portalvv.shared.generated.resources.operational_action_reject
import portalvv.shared.generated.resources.operational_action_save
import portalvv.shared.generated.resources.operational_action_submit
import portalvv.shared.generated.resources.operational_approved_info
import portalvv.shared.generated.resources.operational_cancel
import portalvv.shared.generated.resources.operational_clear_confirm
import portalvv.shared.generated.resources.operational_clear_message
import portalvv.shared.generated.resources.operational_clear_title
import portalvv.shared.generated.resources.operational_corporate_admin_others_percent
import portalvv.shared.generated.resources.operational_corporate_charges
import portalvv.shared.generated.resources.operational_corporate_payroll
import portalvv.shared.generated.resources.operational_corporate_taxes
import portalvv.shared.generated.resources.operational_corporate_title
import portalvv.shared.generated.resources.operational_dashboard_consolidado
import portalvv.shared.generated.resources.operational_dashboard_consolidado_detalhado
import portalvv.shared.generated.resources.operational_dashboard_custos
import portalvv.shared.generated.resources.operational_dashboard_pessoas
import portalvv.shared.generated.resources.operational_dashboard_por_diretoras
import portalvv.shared.generated.resources.operational_dashboard_por_gestoras
import portalvv.shared.generated.resources.operational_dashboard_por_unidades
import portalvv.shared.generated.resources.operational_dashboard_reclamacoes
import portalvv.shared.generated.resources.operational_dashboard_satisfacao
import portalvv.shared.generated.resources.operational_dashboard_visao_geral
import portalvv.shared.generated.resources.operational_detailed_summary_title
import portalvv.shared.generated.resources.operational_discard_confirm
import portalvv.shared.generated.resources.operational_discard_message
import portalvv.shared.generated.resources.operational_discard_title
import portalvv.shared.generated.resources.operational_edit_hint
import portalvv.shared.generated.resources.operational_edit_mode
import portalvv.shared.generated.resources.operational_edit_window_info
import portalvv.shared.generated.resources.operational_entries_select_unit_required
import portalvv.shared.generated.resources.operational_entries_title
import portalvv.shared.generated.resources.operational_entries_unit_label
import portalvv.shared.generated.resources.operational_entries_unit_placeholder
import portalvv.shared.generated.resources.operational_export_success
import portalvv.shared.generated.resources.operational_export_unavailable
import portalvv.shared.generated.resources.operational_history_empty
import portalvv.shared.generated.resources.operational_history_rejected
import portalvv.shared.generated.resources.operational_history_saved
import portalvv.shared.generated.resources.operational_history_title
import portalvv.shared.generated.resources.operational_launch_gestao_financeira
import portalvv.shared.generated.resources.operational_launch_provisionados_mes
import portalvv.shared.generated.resources.operational_launch_reclamacao_cliente
import portalvv.shared.generated.resources.operational_launch_satisfacao_cliente
import portalvv.shared.generated.resources.operational_no_company
import portalvv.shared.generated.resources.operational_panel_title
import portalvv.shared.generated.resources.operational_pending_approvals_title
import portalvv.shared.generated.resources.operational_pending_drafts_title
import portalvv.shared.generated.resources.operational_reject_reason
import portalvv.shared.generated.resources.operational_reject_title
import portalvv.shared.generated.resources.operational_rejected_info
import portalvv.shared.generated.resources.operational_responsible_director
import portalvv.shared.generated.resources.operational_responsible_manager
import portalvv.shared.generated.resources.operational_staff_movement_acquired
import portalvv.shared.generated.resources.operational_staff_movement_col_movement
import portalvv.shared.generated.resources.operational_staff_movement_col_quantity
import portalvv.shared.generated.resources.operational_staff_movement_col_role
import portalvv.shared.generated.resources.operational_staff_movement_empty
import portalvv.shared.generated.resources.operational_staff_movement_hired
import portalvv.shared.generated.resources.operational_staff_movement_terminated
import portalvv.shared.generated.resources.operational_staff_movement_title
import portalvv.shared.generated.resources.operational_staff_movement_transferred
import portalvv.shared.generated.resources.operational_status_approved
import portalvv.shared.generated.resources.operational_status_draft
import portalvv.shared.generated.resources.operational_status_rejected
import portalvv.shared.generated.resources.operational_status_submitted
import portalvv.shared.generated.resources.operational_submit_message
import portalvv.shared.generated.resources.operational_submit_title
import portalvv.shared.generated.resources.operational_submitted_info
import portalvv.shared.generated.resources.operational_subtotal
import portalvv.shared.generated.resources.operational_summary_expense
import portalvv.shared.generated.resources.operational_summary_result
import portalvv.shared.generated.resources.operational_summary_revenue
import portalvv.shared.generated.resources.operational_supplier_add
import portalvv.shared.generated.resources.operational_supplier_current
import portalvv.shared.generated.resources.operational_supplier_installment
import portalvv.shared.generated.resources.operational_supplier_installments
import portalvv.shared.generated.resources.operational_supplier_new_label
import portalvv.shared.generated.resources.operational_supplier_new_placeholder
import portalvv.shared.generated.resources.operational_supplier_remove_confirm
import portalvv.shared.generated.resources.operational_supplier_remove_message
import portalvv.shared.generated.resources.operational_supplier_remove_title
import portalvv.shared.generated.resources.operational_supplier_search
import portalvv.shared.generated.resources.operational_supplier_select_confirm
import portalvv.shared.generated.resources.operational_supplier_select_label
import portalvv.shared.generated.resources.operational_supplier_select_placeholder
import portalvv.shared.generated.resources.operational_supplier_title_add
import portalvv.shared.generated.resources.operational_supplier_title_edit
import portalvv.shared.generated.resources.operational_supplier_use_existing
import portalvv.shared.generated.resources.operational_supplier_use_new
import portalvv.shared.generated.resources.operational_under_construction
import portalvv.shared.generated.resources.operational_updated_info
import portalvv.shared.generated.resources.undrawable_to_do_list

enum class DashboardType(
    val title: StringResource,
    val permission: String? = null,
) {
    VISAO_GERAL(Res.string.operational_dashboard_visao_geral),
    POR_DIRETORAS(Res.string.operational_dashboard_por_diretoras, permission = PermissionKeys.SEE_DIRECTORS),
    POR_GESTORAS(Res.string.operational_dashboard_por_gestoras, permission = PermissionKeys.SEE_MANAGERS),
    POR_UNIDADES(Res.string.operational_dashboard_por_unidades),
    CUSTOS(Res.string.operational_dashboard_custos),
    CONSOLIDADO(Res.string.operational_dashboard_consolidado),
    CONSOLIDADO_DETALHADO(Res.string.operational_dashboard_consolidado_detalhado),
    PESSOAS(Res.string.operational_dashboard_pessoas),
    RECLAMACOES(Res.string.operational_dashboard_reclamacoes),
    SATISFACAO(Res.string.operational_dashboard_satisfacao),
}

@Composable
fun OperationalPanelScreen() {
    OperationalPanelContent()
}

@Composable
private fun OperationalPanelContent() {
    var selectedType by remember { mutableStateOf(DashboardType.VISAO_GERAL) }
    val focusManager = LocalFocusManager.current
    val permissions = rememberSessionPermissions()
    val visibleTypes = DashboardType.entries.filter { it.permission == null || it.permission in permissions }

    AppScrollColumn(
        modifier =
            Modifier
                .fillMaxSize()
                .pointerInput(Unit) {
                    detectTapGestures { focusManager.clearFocus() }
                },
        contentPadding = PaddingValues(AppSpacing.space24),
        verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
        footer = { AppFooter() },
    ) {
        Text(
            text = stringResource(Res.string.operational_panel_title),
            style = MaterialTheme.typography.headlineMedium,
        )

        PeriodSelector(modifier = Modifier.fillMaxWidth())

        PrimaryScrollableTabRow(selectedTabIndex = visibleTypes.indexOf(selectedType).coerceAtLeast(0)) {
            visibleTypes.forEach { type ->
                Tab(
                    selected = type == selectedType,
                    onClick = { selectedType = type },
                    text = { Text(text = stringResource(type.title)) },
                )
            }
        }

        when (selectedType) {
            DashboardType.VISAO_GERAL -> OverviewContent()
            DashboardType.POR_GESTORAS -> ManagersContent()
            DashboardType.POR_DIRETORAS -> DirectorsContent()
            DashboardType.POR_UNIDADES -> UnitsContent()
            DashboardType.CUSTOS -> CostsContent()
            DashboardType.CONSOLIDADO -> ConsolidatedContent()
            DashboardType.CONSOLIDADO_DETALHADO -> ConsolidatedDetailedContent()
            DashboardType.PESSOAS -> PeopleContent()
            DashboardType.RECLAMACOES -> ComplaintsContent()
            DashboardType.SATISFACAO -> SatisfactionDashboardContent()
        }
    }
}

enum class LaunchType(
    val title: StringResource,
    val entryKind: OperationalEntryKind?,
) {
    GESTAO_FINANCEIRA(Res.string.operational_launch_gestao_financeira, OperationalEntryKind.GESTAO_FINANCEIRA),
    PROVISIONADOS_MES(Res.string.operational_launch_provisionados_mes, OperationalEntryKind.PROVISIONADOS_MES),
    RECLAMACAO_CLIENTE(Res.string.operational_launch_reclamacao_cliente, null),
    SATISFACAO_CLIENTE(Res.string.operational_launch_satisfacao_cliente, null),
}

@Composable
fun OperationalEntriesScreen() {
    var selectedType by remember { mutableStateOf(LaunchType.GESTAO_FINANCEIRA) }
    var entryEditing by remember { mutableStateOf(false) }
    var backSignal by remember { mutableStateOf(0) }
    val filters = LocalGlobalFilters.current
    var selectedUnit by remember { mutableStateOf<CompanyRef?>(null) }
    var selectedMonth by remember { mutableStateOf(SystemDateTimeProvider().currentPeriod()) }
    val focusManager = LocalFocusManager.current
    var toast by remember { mutableStateOf<StringResource?>(null) }

    val appGraph = LocalAppGraph.current
    val permissions = rememberSessionPermissions()
    val canApprove = PermissionKeys.OPERATIONAL_ENTRIES_APPROVE in permissions
    val canEditEntries =
        permissions.allows(PermissionKeys.OPERATIONAL_ENTRIES, PermissionAction.EDIT) ||
            permissions.allows(PermissionKeys.OPERATIONAL_ENTRIES, PermissionAction.CREATE)
    var pendingApprovals by remember { mutableStateOf<List<PendingEntryUnit>>(emptyList()) }
    var pendingDrafts by remember { mutableStateOf<List<PendingEntryUnit>>(emptyList()) }
    var pendingRefresh by remember { mutableStateOf(0) }

    LaunchedEffect(canApprove, pendingRefresh) {
        pendingApprovals =
            if (canApprove) {
                runCatching { appGraph.operationalEntryRepository.pendingApprovals() }.getOrDefault(emptyList())
            } else {
                emptyList()
            }
    }

    LaunchedEffect(canEditEntries, pendingRefresh) {
        pendingDrafts =
            if (canEditEntries) {
                runCatching { appGraph.operationalEntryRepository.pendingDrafts() }.getOrDefault(emptyList())
            } else {
                emptyList()
            }
    }

    LaunchedEffect(toast) {
        if (toast != null) {
            delay(2500)
            toast = null
        }
    }

    LaunchedEffect(filters.unit, filters.units) {
        val headerUnit = filters.selectedUnit
        selectedUnit =
            when {
                headerUnit != null -> headerUnit
                selectedUnit?.let { current -> filters.units.any { it.name == current.name } } == true -> selectedUnit
                else -> filters.units.singleOrNull()
            }
    }

    LaunchedEffect(selectedType) { entryEditing = false }

    val unitPlaceholder = stringResource(Res.string.operational_entries_unit_placeholder)
    val unitOptions = listOf(unitPlaceholder) + filters.units.map { it.name }

    Box(modifier = Modifier.fillMaxSize()) {
        AppScrollColumn(
            modifier =
                Modifier
                    .fillMaxSize()
                    .pointerInput(Unit) {
                        detectTapGestures { focusManager.clearFocus() }
                    },
            contentPadding = PaddingValues(AppSpacing.space24),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
            footer = { AppFooter() },
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.SpaceBetween,
            ) {
                Text(
                    text = stringResource(Res.string.operational_entries_title),
                    style = MaterialTheme.typography.headlineMedium,
                )
                if (entryEditing) {
                    AppButton(
                        text = stringResource(Res.string.back),
                        onClick = { backSignal++ },
                        variant = PortalButtonVariant.Text,
                        leadingIcon = Lucide.ArrowLeft,
                    )
                }
            }

            if (canApprove && pendingApprovals.isNotEmpty()) {
                PendingEntriesCard(
                    title = stringResource(Res.string.operational_pending_approvals_title, pendingApprovals.size),
                    units = pendingApprovals,
                    icon = Lucide.Bell,
                    containerColor = AppPalette.Warning100,
                    borderColor = AppPalette.Warning500,
                    contentColor = AppPalette.Warning900,
                    onSelect = { pending ->
                        filters.selectUnit(pending.name)
                        selectedMonth = pending.period
                    },
                )
            }

            if (canEditEntries && pendingDrafts.isNotEmpty()) {
                PendingEntriesCard(
                    title = stringResource(Res.string.operational_pending_drafts_title, pendingDrafts.size),
                    units = pendingDrafts,
                    icon = Lucide.Pencil,
                    containerColor = AppPalette.Info100,
                    borderColor = AppPalette.Info500,
                    contentColor = AppPalette.Info900,
                    onSelect = { pending ->
                        filters.selectUnit(pending.name)
                        selectedMonth = pending.period
                    },
                )
            }

            EntriesFiltersCard(
                unitOptions = unitOptions,
                selectedUnit = selectedUnit,
                unitPlaceholder = unitPlaceholder,
                onSelectUnit = { name ->
                    selectedUnit = if (name == unitPlaceholder) null else filters.units.firstOrNull { it.name == name }
                },
                unitEnabled = !entryEditing,
                month = selectedMonth,
                onMonthChange = { selectedMonth = it },
            )

            LaunchTypeTabs(selected = selectedType, onSelect = { selectedType = it })

            val unit = selectedUnit
            if (unit == null) {
                EmptyState(
                    message = stringResource(Res.string.operational_entries_select_unit_required),
                    drawable = Res.drawable.undrawable_to_do_list,
                )
            } else {
                val entryKind = selectedType.entryKind
                when {
                    selectedType == LaunchType.SATISFACAO_CLIENTE -> SatisfactionContent(unit = unit, month = selectedMonth)
                    selectedType == LaunchType.RECLAMACAO_CLIENTE -> ComplaintContent(unit = unit, month = selectedMonth)
                    entryKind == null -> UnderConstructionContent(title = stringResource(selectedType.title))
                    else ->
                        OperationalEntryContent(
                            kind = entryKind,
                            unit = unit,
                            month = selectedMonth,
                            onEditingChanged = { entryEditing = it },
                            backSignal = backSignal,
                            onToast = { toast = it },
                            onReviewed = { pendingRefresh++ },
                        )
                }
            }
        }
        toast?.let { message ->
            AppToast(
                message = message,
                modifier = Modifier.align(Alignment.BottomCenter).padding(bottom = AppSpacing.space24),
            )
        }
    }
}

private val ENTRIES_FILTERS_MIN_WIDTH = 720.dp
private val HEADER_CARD_MIN_WIDTH = 640.dp

@Composable
private fun EntriesFiltersCard(
    unitOptions: List<String>,
    selectedUnit: CompanyRef?,
    unitPlaceholder: String,
    onSelectUnit: (String) -> Unit,
    unitEnabled: Boolean,
    month: MonthPeriod,
    onMonthChange: (MonthPeriod) -> Unit,
) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.medium,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
            if (maxWidth >= ENTRIES_FILTERS_MIN_WIDTH) {
                Row(
                    modifier = Modifier.fillMaxWidth().padding(horizontal = AppSpacing.space12, vertical = AppSpacing.space8),
                    horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
                        Text(
                            text = stringResource(Res.string.operational_entries_unit_label),
                            style = MaterialTheme.typography.labelMedium,
                            color = MaterialTheme.colorScheme.onSurfaceVariant,
                        )
                        SearchableSelect(
                            leadingIcon = Lucide.Building,
                            options = unitOptions,
                            selected = selectedUnit?.name ?: unitPlaceholder,
                            onSelect = onSelectUnit,
                            modifier = Modifier.fillMaxWidth(),
                            underlined = true,
                            enabled = unitEnabled,
                            searchable = true,
                        )
                    }
                    MonthPeriodSelector(month = month, onMonthChange = onMonthChange)
                }
            } else {
                Column(
                    modifier = Modifier.fillMaxWidth().padding(AppSpacing.space12),
                    verticalArrangement = Arrangement.spacedBy(AppSpacing.space12),
                ) {
                    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
                        Text(
                            text = stringResource(Res.string.operational_entries_unit_label),
                            style = MaterialTheme.typography.labelMedium,
                            color = MaterialTheme.colorScheme.onSurfaceVariant,
                        )
                        SearchableSelect(
                            leadingIcon = Lucide.Building,
                            options = unitOptions,
                            selected = selectedUnit?.name ?: unitPlaceholder,
                            onSelect = onSelectUnit,
                            modifier = Modifier.fillMaxWidth(),
                            underlined = true,
                            enabled = unitEnabled,
                            searchable = true,
                        )
                    }
                    MonthPeriodSelector(month = month, onMonthChange = onMonthChange)
                }
            }
        }
    }
}

@Composable
private fun PendingEntriesCard(
    title: String,
    units: List<PendingEntryUnit>,
    icon: ImageVector,
    containerColor: Color,
    borderColor: Color,
    contentColor: Color,
    onSelect: (PendingEntryUnit) -> Unit,
) {
    var expanded by remember { mutableStateOf(false) }
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.medium,
        color = containerColor,
        border = BorderStroke(1.dp, borderColor),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            Row(
                modifier = Modifier.fillMaxWidth().clickable { expanded = !expanded },
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
            ) {
                Icon(imageVector = icon, contentDescription = null, tint = contentColor)
                Text(
                    text = title,
                    style = MaterialTheme.typography.titleSmall,
                    color = contentColor,
                    modifier = Modifier.weight(1f),
                )
                Icon(
                    imageVector = Lucide.ChevronDown,
                    contentDescription = null,
                    tint = contentColor,
                    modifier = Modifier.graphicsLayer { rotationZ = if (expanded) 180f else 0f },
                )
            }
            if (expanded) {
                units.forEach { pending ->
                    Row(
                        modifier =
                            Modifier
                                .fillMaxWidth()
                                .clickable {
                                    onSelect(pending)
                                    expanded = false
                                }.padding(vertical = AppSpacing.space4),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
                    ) {
                        Icon(
                            imageVector = Lucide.Building,
                            contentDescription = null,
                            tint = contentColor,
                            modifier = Modifier.size(16.dp),
                        )
                        Text(
                            text = pending.name,
                            style = MaterialTheme.typography.bodyMedium,
                            color = contentColor,
                            modifier = Modifier.weight(1f),
                        )
                        Text(
                            text = MonthCalendar.label(pending.period),
                            style = MaterialTheme.typography.labelMedium,
                            color = contentColor,
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun LaunchTypeTabs(
    selected: LaunchType,
    onSelect: (LaunchType) -> Unit,
) {
    PrimaryScrollableTabRow(selectedTabIndex = selected.ordinal) {
        LaunchType.entries.forEach { type ->
            Tab(
                selected = type == selected,
                onClick = { onSelect(type) },
                text = { Text(text = stringResource(type.title)) },
            )
        }
    }
}

@Composable
private fun OperationalEntryContent(
    kind: OperationalEntryKind,
    unit: CompanyRef,
    month: MonthPeriod,
    onEditingChanged: (Boolean) -> Unit,
    backSignal: Int,
    onToast: (StringResource) -> Unit,
    onReviewed: () -> Unit,
) {
    val controller = rememberOperationalEntriesController(kind)
    val filters = LocalGlobalFilters.current

    LaunchedEffect(controller.toastMessage) {
        controller.toastMessage?.let { message ->
            onToast(message)
            controller.toastMessage = null
        }
    }

    LaunchedEffect(controller.refreshToken) {
        if (controller.refreshToken > 0) onReviewed()
    }

    LaunchedEffect(controller, unit, month, filters.units) {
        controller.applyPeriod(month)
        controller.start(unit, filters.units)
    }

    LaunchedEffect(controller.editing) { onEditingChanged(controller.editing) }

    LaunchedEffect(backSignal) {
        if (backSignal > 0 && controller.editing) controller.requestCancelEdit()
    }

    var exportMessage by remember { mutableStateOf<StringResource?>(null) }

    HeaderCard(
        controller = controller,
        onExportPdf = { report ->
            val entry = controller.entry
            val saved = entry != null && exportEntryPdf(entry, report)
            exportMessage = if (saved) Res.string.operational_export_success else Res.string.operational_export_unavailable
        },
    )

    if (controller.editing) {
        EditModeBanner()
    }

    controller.message?.let { message ->
        AppBanner(text = stringResource(message), onDismiss = controller::dismissMessage)
    }

    exportMessage?.let { message ->
        AppBanner(text = stringResource(message), onDismiss = { exportMessage = null })
    }

    val current = controller.entry
    when {
        controller.loading -> LoadingBox()
        current == null -> EmptyState(message = stringResource(Res.string.operational_no_company))
        else -> {
            SummaryCard(current)
            if (hasStatusInfo(current)) StatusCard(entry = current)
            key(controller.clearToken) {
                current.tables.forEach { table ->
                    val supplierTable = table.kind == EntryTableKind.EXPENSE
                    OperationalEntryTable(
                        table = table,
                        weeks = controller.weeks,
                        editing = controller.editing,
                        onWeekChange = controller::updateWeek,
                        collapsible = supplierTable,
                        initiallyExpanded = !supplierTable,
                        onAddSupplier = if (supplierTable && controller.editing) ({ controller.openAddSupplier(table.id) }) else null,
                        onEditSupplier = if (supplierTable && controller.editing) ({ row -> controller.openEditSupplier(table.id, row) }) else null,
                        onRemoveSupplier = if (supplierTable && controller.editing) ({ row -> controller.requestRemoveSupplier(row.id) }) else null,
                        onFieldBlur = controller::autosave,
                    )
                }
            }
            CorporateCardsRow(entry = current)
            DetailedSummaryCard(current)
            HistoryCard(current)
        }
    }

    if (controller.rejectOpen) {
        RejectDialog(controller)
    }

    if (controller.cancelConfirmOpen) {
        DiscardDialog(controller)
    }

    if (controller.submitConfirmOpen) {
        SubmitDialog(controller)
    }

    if (controller.supplierDialogOpen) {
        SupplierDialog(controller)
    }

    if (controller.removeSupplierRowId != null) {
        RemoveSupplierDialog(controller)
    }

    if (controller.clearConfirmOpen) {
        ClearDialog(controller)
    }
}

private fun exportEntryPdf(
    entry: OperationalEntry,
    report: PdfReport,
): Boolean {
    val base64 = encodeBase64(PdfWriter.build(report))
    val sanitized =
        "lancamento-${entry.companyName}-${entry.period.id}"
            .map { if (it.isLetterOrDigit() || it == '-' || it == '_' || it == '.') it else '_' }
            .joinToString("")
    return savePdf("$sanitized.pdf", base64)
}

@Composable
private fun HeaderCard(
    controller: OperationalEntriesController,
    onExportPdf: (PdfReport) -> Unit,
) {
    val report =
        controller.entry?.let {
            buildOperationalEntryReport(
                entry = it,
                directorNames = controller.responsibleDirectorNames,
                managerNames = controller.responsibleManagerNames,
            )
        }
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
            if (maxWidth >= HEADER_CARD_MIN_WIDTH) {
                Row(
                    modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
                    verticalAlignment = Alignment.Top,
                    horizontalArrangement = Arrangement.spacedBy(AppSpacing.space16),
                ) {
                    HeaderInfo(controller = controller, modifier = Modifier.weight(1f))
                    HeaderStatusActions(controller = controller, report = report, onExportPdf = onExportPdf, alignment = Alignment.End)
                }
            } else {
                Column(
                    modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
                    verticalArrangement = Arrangement.spacedBy(AppSpacing.space12),
                ) {
                    HeaderInfo(controller = controller, modifier = Modifier.fillMaxWidth())
                    HeaderStatusActions(controller = controller, report = report, onExportPdf = onExportPdf, alignment = Alignment.Start)
                }
            }
        }
    }
}

@Composable
private fun HeaderInfo(
    controller: OperationalEntriesController,
    modifier: Modifier = Modifier,
) {
    Column(modifier = modifier, verticalArrangement = Arrangement.spacedBy(AppSpacing.space12)) {
        Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
            Text(
                text = stringResource(Res.string.operational_responsible_director),
                style = MaterialTheme.typography.labelMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            Text(
                text = controller.responsibleDirectorNames.joinToString(", ").ifEmpty { "-" },
                style = MaterialTheme.typography.titleMedium,
            )
        }
        Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
            Text(
                text = stringResource(Res.string.operational_responsible_manager),
                style = MaterialTheme.typography.labelMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            Text(
                text = controller.responsibleManagerNames.joinToString(", ").ifEmpty { "-" },
                style = MaterialTheme.typography.titleMedium,
            )
        }
    }
}

@Composable
private fun HeaderStatusActions(
    controller: OperationalEntriesController,
    report: PdfReport?,
    onExportPdf: (PdfReport) -> Unit,
    alignment: Alignment.Horizontal,
) {
    Column(
        horizontalAlignment = alignment,
        verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
    ) {
        if (controller.supportsApproval) {
            controller.entry?.status?.let { status -> StatusBadge(status) }
        }
        ActionRow(controller = controller, report = report, onExportPdf = onExportPdf)
        Text(
            text = stringResource(Res.string.operational_edit_window_info),
            style = MaterialTheme.typography.bodySmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun ActionRow(
    controller: OperationalEntriesController,
    report: PdfReport?,
    onExportPdf: (PdfReport) -> Unit,
) {
    if (controller.entry == null) return
    FlowRow(
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
    ) {
        if (report != null && !controller.editing && isPdfExportSupported()) {
            AppButton(
                text = stringResource(Res.string.operational_action_export_pdf),
                onClick = { onExportPdf(report) },
                variant = PortalButtonVariant.Outlined,
                leadingIcon = Lucide.FileDown,
            )
        }
        if (controller.editing) {
            AppButton(
                text = stringResource(Res.string.operational_action_clear),
                onClick = controller::requestClear,
                variant = PortalButtonVariant.Text,
                leadingIcon = Lucide.Eraser,
            )
            AppButton(
                text = stringResource(Res.string.operational_action_save),
                onClick = controller::saveDraft,
                variant = PortalButtonVariant.Outlined,
                leadingIcon = Lucide.Save,
            )
            if (controller.supportsApproval) {
                AppButton(
                    text = stringResource(Res.string.operational_action_submit),
                    onClick = controller::requestSubmit,
                    leadingIcon = Lucide.Send,
                )
            }
        } else if (controller.canEdit && controller.editable) {
            AppButton(
                text = stringResource(Res.string.operational_action_edit),
                onClick = controller::startEdit,
                leadingIcon = Lucide.Pencil,
            )
        }
        if (controller.canReview) {
            AppButton(
                text = stringResource(Res.string.operational_action_approve),
                onClick = controller::approve,
                leadingIcon = Lucide.Check,
            )
            AppButton(
                text = stringResource(Res.string.operational_action_reject),
                onClick = controller::openReject,
                variant = PortalButtonVariant.Outlined,
                leadingIcon = Lucide.Ban,
            )
        }
    }
}

private fun hasStatusInfo(entry: OperationalEntry): Boolean =
    entry.submittedAt != null ||
        (entry.status == OperationalEntryStatus.APPROVED && entry.reviewedAt != null) ||
        entry.status == OperationalEntryStatus.REJECTED

@Composable
private fun StatusCard(entry: OperationalEntry) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space4),
        ) {
            if (entry.submittedAt != null) {
                Text(
                    text = stringResource(Res.string.operational_submitted_info, entry.submittedBy, entry.submittedAt),
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            }
            if (entry.status == OperationalEntryStatus.APPROVED && entry.reviewedAt != null) {
                Text(
                    text = stringResource(Res.string.operational_approved_info, entry.reviewedBy, entry.reviewedAt),
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            }
            if (entry.status == OperationalEntryStatus.REJECTED) {
                Text(
                    text = stringResource(Res.string.operational_rejected_info, entry.reviewedBy, entry.rejectionReason),
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.error,
                )
            }
            if (entry.updatedAt.isNotBlank()) {
                Text(
                    text = stringResource(Res.string.operational_updated_info, entry.updatedBy.ifBlank { "-" }, entry.updatedAt),
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            }
        }
    }
}

@Composable
private fun SummaryCard(entry: OperationalEntry) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space24),
        ) {
            SummaryItem(
                icon = Lucide.TrendingUp,
                iconColor = AppPalette.Success500,
                iconContainerColor = AppPalette.Success100,
                label = Res.string.operational_summary_revenue,
                cents = entry.revenueTotalCents,
                modifier = Modifier.weight(1f),
            )
            SummaryItem(
                icon = Lucide.TrendingDown,
                iconColor = AppPalette.Error500,
                iconContainerColor = AppPalette.Error100,
                label = Res.string.operational_summary_expense,
                cents = entry.expenseTotalCents,
                modifier = Modifier.weight(1f),
            )
            SummaryItem(
                icon = Lucide.Scale,
                iconColor = if (entry.resultCents < 0) AppPalette.Error500 else AppPalette.Success500,
                iconContainerColor = if (entry.resultCents < 0) AppPalette.Error100 else AppPalette.Success100,
                label = Res.string.operational_summary_result,
                cents = entry.resultCents,
                percent = entry.resultPercent,
                color = if (entry.resultCents < 0) AppPalette.Error500 else AppPalette.Success500,
                modifier = Modifier.weight(1f),
            )
        }
    }
}

@Composable
private fun SummaryItem(
    icon: ImageVector,
    iconColor: Color,
    iconContainerColor: Color,
    label: StringResource,
    cents: Long,
    modifier: Modifier = Modifier,
    color: Color = MaterialTheme.colorScheme.onSurface,
    percent: Double? = null,
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
    ) {
        Surface(
            shape = AppShapes.small,
            color = iconContainerColor,
            modifier = Modifier.size(36.dp),
        ) {
            Box(contentAlignment = Alignment.Center) {
                Icon(
                    imageVector = icon,
                    contentDescription = null,
                    tint = iconColor,
                    modifier = Modifier.size(18.dp),
                )
            }
        }
        Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
            Text(
                text = stringResource(label),
                style = MaterialTheme.typography.labelMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            Text(
                text = moneyWithPercent(cents, percent),
                style = MaterialTheme.typography.titleMedium,
                color = color,
            )
        }
    }
}

@Composable
private fun DetailedSummaryCard(entry: OperationalEntry) {
    val revenueTable = entry.tables.firstOrNull { it.kind == EntryTableKind.REVENUE }
    val expenseTables = entry.tables.filter { it.kind == EntryTableKind.EXPENSE }
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            Text(
                text = stringResource(Res.string.operational_detailed_summary_title),
                style = MaterialTheme.typography.titleMedium,
            )
            if (revenueTable != null) {
                SectionTitle(stringResource(revenueTable.title))
                revenueTable.rows.forEach { row ->
                    SummaryLine(label = entryRowLabel(row), cents = row.totalCents)
                }
                SummaryLine(
                    label = stringResource(Res.string.operational_subtotal),
                    cents = revenueTable.totalCents,
                    emphasis = true,
                )
            }
            HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
            SectionTitle(stringResource(Res.string.operational_summary_expense))
            expenseTables.forEach { table ->
                SummaryLine(label = stringResource(table.title), cents = table.totalCents)
            }
            SectionTitle(stringResource(Res.string.operational_corporate_title))
            SummaryLine(label = stringResource(Res.string.operational_corporate_payroll), cents = entry.corporatePayrollCents)
            SummaryLine(label = stringResource(Res.string.operational_corporate_charges), cents = entry.corporateChargesCents)
            SummaryLine(
                label =
                    stringResource(
                        Res.string.operational_corporate_admin_others_percent,
                        PercentFormatter.format(entry.adminOthersPercent),
                    ),
                cents = entry.corporateAdminOthersCents,
            )
            SummaryLine(label = stringResource(Res.string.operational_corporate_taxes), cents = entry.corporateTaxesCents)
            SummaryLine(
                label = stringResource(Res.string.operational_subtotal),
                cents = entry.expenseTotalCents,
                emphasis = true,
            )
            HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
            SummaryLine(
                label = stringResource(Res.string.operational_summary_result),
                cents = entry.resultCents,
                emphasis = true,
                color = if (entry.resultCents < 0) AppPalette.Error500 else AppPalette.Success500,
                percent = entry.resultPercent,
            )
        }
    }
}

@Composable
private fun CorporateExpensesCard(
    entry: OperationalEntry,
    modifier: Modifier = Modifier,
) {
    Surface(
        modifier = modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            Text(
                text = stringResource(Res.string.operational_corporate_title),
                style = MaterialTheme.typography.titleMedium,
            )
            SummaryLine(label = stringResource(Res.string.operational_corporate_payroll), cents = entry.corporatePayrollCents)
            SummaryLine(label = stringResource(Res.string.operational_corporate_charges), cents = entry.corporateChargesCents)
            SummaryLine(
                label =
                    stringResource(
                        Res.string.operational_corporate_admin_others_percent,
                        PercentFormatter.format(entry.adminOthersPercent),
                    ),
                cents = entry.corporateAdminOthersCents,
            )
            SummaryLine(label = stringResource(Res.string.operational_corporate_taxes), cents = entry.corporateTaxesCents)
            HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
            SummaryLine(label = stringResource(Res.string.operational_subtotal), cents = entry.corporateTotalCents, emphasis = true)
        }
    }
}

private val CORPORATE_ROW_MIN_WIDTH = 900.dp

@Composable
private fun CorporateCardsRow(entry: OperationalEntry) {
    BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
        if (maxWidth >= CORPORATE_ROW_MIN_WIDTH) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space16),
            ) {
                StaffMovementCard(movement = entry.staffMovements, modifier = Modifier.weight(1f))
                CorporateExpensesCard(entry = entry, modifier = Modifier.weight(1f))
            }
        } else {
            Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space16)) {
                StaffMovementCard(movement = entry.staffMovements)
                CorporateExpensesCard(entry = entry)
            }
        }
    }
}

@Composable
private fun StaffMovementCard(
    movement: List<StaffMovement>,
    modifier: Modifier = Modifier,
) {
    Surface(
        modifier = modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            Text(
                text = stringResource(Res.string.operational_staff_movement_title),
                style = MaterialTheme.typography.titleMedium,
            )
            if (movement.isEmpty()) {
                Text(
                    text = stringResource(Res.string.operational_staff_movement_empty),
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            } else {
                StaffMovementRow(
                    movement = stringResource(Res.string.operational_staff_movement_col_movement),
                    role = stringResource(Res.string.operational_staff_movement_col_role),
                    quantity = stringResource(Res.string.operational_staff_movement_col_quantity),
                    header = true,
                )
                movement.forEach { item ->
                    StaffMovementRow(
                        movement = stringResource(item.movement.label()),
                        role = item.role,
                        quantity = item.quantity.toString(),
                        header = false,
                    )
                }
            }
        }
    }
}

@Composable
private fun StaffMovementRow(
    movement: String,
    role: String,
    quantity: String,
    header: Boolean,
) {
    val style = if (header) MaterialTheme.typography.labelMedium else MaterialTheme.typography.bodyMedium
    val color = if (header) MaterialTheme.colorScheme.onSurfaceVariant else MaterialTheme.colorScheme.onSurface
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Text(
            text = movement,
            style = style,
            color = color,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis,
            modifier = Modifier.weight(1.2f),
        )
        Text(
            text = role,
            style = style,
            color = color,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis,
            modifier = Modifier.weight(1.5f),
        )
        Text(
            text = quantity,
            style = style,
            color = color,
            textAlign = TextAlign.End,
            maxLines = 1,
            modifier = Modifier.weight(0.8f),
        )
    }
}

internal fun StaffMovementType.label(): StringResource =
    when (this) {
        StaffMovementType.HIRED -> Res.string.operational_staff_movement_hired
        StaffMovementType.TERMINATED -> Res.string.operational_staff_movement_terminated
        StaffMovementType.TRANSFERRED -> Res.string.operational_staff_movement_transferred
        StaffMovementType.ACQUIRED -> Res.string.operational_staff_movement_acquired
    }

@Composable
private fun SectionTitle(text: String) {
    Text(
        text = text,
        style = MaterialTheme.typography.labelMedium,
        color = MaterialTheme.colorScheme.onSurfaceVariant,
    )
}

@Composable
private fun SummaryLine(
    label: String,
    cents: Long,
    emphasis: Boolean = false,
    color: Color = MaterialTheme.colorScheme.onSurface,
    percent: Double? = null,
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Text(
            text = label,
            style = if (emphasis) MaterialTheme.typography.labelLarge else MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurface,
            modifier = Modifier.weight(1f),
        )
        Text(
            text = moneyWithPercent(cents, percent),
            style = if (emphasis) MaterialTheme.typography.labelLarge else MaterialTheme.typography.bodyMedium,
            color = color,
            textAlign = TextAlign.End,
        )
    }
}

private fun moneyWithPercent(
    cents: Long,
    percent: Double?,
): String = "R$ ${MoneyFormatter.formatCents(cents)}" + (percent?.let { " (${PercentFormatter.format(it)}%)" } ?: "")

@Composable
private fun entryRowLabel(row: EntryRow): String =
    when (val label = row.label) {
        is EntryRowLabel.Resource -> stringResource(label.value)
        is EntryRowLabel.Supplier -> label.value
    }

@Composable
private fun HistoryCard(entry: OperationalEntry) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
        ) {
            Text(
                text = stringResource(Res.string.operational_history_title),
                style = MaterialTheme.typography.titleMedium,
            )
            if (entry.history.isEmpty()) {
                Text(
                    text = stringResource(Res.string.operational_history_empty),
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            } else {
                entry.history.asReversed().forEach { event ->
                    HistoryLine(event)
                }
            }
        }
    }
}

@Composable
private fun HistoryLine(event: OperationalEntryEvent) {
    val icon =
        when (event.type) {
            OperationalEntryEventType.SAVED -> Lucide.Pencil
            OperationalEntryEventType.SUBMITTED -> Lucide.Send
            OperationalEntryEventType.APPROVED -> Lucide.Check
            OperationalEntryEventType.REJECTED -> Lucide.Ban
        }
    val text =
        when (event.type) {
            OperationalEntryEventType.SAVED -> stringResource(Res.string.operational_history_saved, event.actorName, event.at)
            OperationalEntryEventType.SUBMITTED -> stringResource(Res.string.operational_submitted_info, event.actorName, event.at)
            OperationalEntryEventType.APPROVED -> stringResource(Res.string.operational_approved_info, event.actorName, event.at)
            OperationalEntryEventType.REJECTED -> stringResource(Res.string.operational_history_rejected, event.actorName, event.at, event.note)
        }
    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
    ) {
        Icon(
            imageVector = icon,
            contentDescription = null,
            tint = MaterialTheme.colorScheme.onSurfaceVariant,
            modifier = Modifier.size(18.dp),
        )
        Text(
            text = text,
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurface,
        )
    }
}

@Composable
private fun StatusBadge(status: OperationalEntryStatus) {
    val colors = status.badgeColors()
    AppBadge(
        text = status.label(),
        containerColor = colors.first,
        contentColor = colors.second,
    )
}

@Composable
private fun RejectDialog(controller: OperationalEntriesController) {
    AppModalCard(
        title = stringResource(Res.string.operational_reject_title),
        onDismiss = controller::cancelReject,
    ) {
        AppTextField(
            value = controller.rejectReason,
            onValueChange = controller::updateRejectReason,
            label = stringResource(Res.string.operational_reject_reason),
            modifier = Modifier.fillMaxWidth(),
        )
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.operational_cancel),
                onClick = controller::cancelReject,
                variant = PortalButtonVariant.Text,
            )
            AppButton(
                text = stringResource(Res.string.operational_action_reject),
                onClick = controller::confirmReject,
                enabled = controller.rejectReason.isNotBlank(),
            )
        }
    }
}

@Composable
private fun EditModeBanner() {
    val colors = PortalTheme.extraColors
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.medium,
        color = colors.infoContainer,
        contentColor = colors.onInfoContainer,
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space4),
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
            ) {
                Icon(
                    imageVector = Lucide.Pencil,
                    contentDescription = null,
                    modifier = Modifier.size(18.dp),
                )
                Text(
                    text = stringResource(Res.string.operational_edit_mode),
                    style = MaterialTheme.typography.titleSmall,
                )
            }
            Text(
                text = stringResource(Res.string.operational_edit_hint),
                style = MaterialTheme.typography.bodyMedium,
            )
        }
    }
}

@Composable
private fun DiscardDialog(controller: OperationalEntriesController) {
    AppModalCard(
        title = stringResource(Res.string.operational_discard_title),
        onDismiss = controller::dismissCancelEdit,
    ) {
        Text(
            text = stringResource(Res.string.operational_discard_message),
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.operational_cancel),
                onClick = controller::dismissCancelEdit,
                variant = PortalButtonVariant.Text,
            )
            AppButton(
                text = stringResource(Res.string.operational_discard_confirm),
                onClick = controller::confirmCancelEdit,
            )
        }
    }
}

@Composable
private fun SubmitDialog(controller: OperationalEntriesController) {
    AppModalCard(
        title = stringResource(Res.string.operational_submit_title),
        onDismiss = controller::dismissSubmit,
    ) {
        Text(
            text = stringResource(Res.string.operational_submit_message),
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.operational_cancel),
                onClick = controller::dismissSubmit,
                variant = PortalButtonVariant.Text,
            )
            AppButton(
                text = stringResource(Res.string.operational_action_submit),
                onClick = controller::confirmSubmit,
                leadingIcon = Lucide.Send,
            )
        }
    }
}

@Composable
private fun ClearDialog(controller: OperationalEntriesController) {
    AppModalCard(
        title = stringResource(Res.string.operational_clear_title),
        onDismiss = controller::dismissClear,
    ) {
        Text(
            text = stringResource(Res.string.operational_clear_message),
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.operational_cancel),
                onClick = controller::dismissClear,
                variant = PortalButtonVariant.Text,
            )
            AppButton(
                text = stringResource(Res.string.operational_clear_confirm),
                onClick = controller::confirmClear,
            )
        }
    }
}

@Composable
private fun SupplierDialog(controller: OperationalEntriesController) {
    val selectedName =
        controller.supplierDialogSupplierId
            ?.let { id -> controller.availableSuppliers.firstOrNull { it.id == id }?.name }
            .orEmpty()
    AppModalCard(
        title = stringResource(if (controller.supplierDialogIsEdit) Res.string.operational_supplier_title_edit else Res.string.operational_supplier_title_add),
        onDismiss = controller::dismissSupplierDialog,
    ) {
        when (controller.supplierDialogMode) {
            SupplierDialogMode.SELECT -> {
                Text(
                    text = stringResource(Res.string.operational_supplier_select_label),
                    style = MaterialTheme.typography.labelMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
                SearchableSelect(
                    leadingIcon = Lucide.Package,
                    options = controller.supplierOptions,
                    selected = selectedName.ifEmpty { stringResource(Res.string.operational_supplier_select_placeholder) },
                    onSelect = { name ->
                        controller.availableSuppliers.firstOrNull { it.name == name }?.let { controller.selectSupplier(it.id) }
                    },
                    searchPlaceholder = stringResource(Res.string.operational_supplier_search),
                    searchable = true,
                )
                AppButton(
                    text = stringResource(Res.string.operational_supplier_use_new),
                    onClick = controller::useNewSupplier,
                    variant = PortalButtonVariant.Text,
                    leadingIcon = Lucide.Plus,
                )
            }
            SupplierDialogMode.NEW -> {
                Text(
                    text = stringResource(Res.string.operational_supplier_new_label),
                    style = MaterialTheme.typography.labelMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
                AppTextField(
                    value = controller.supplierDialogNewName,
                    onValueChange = controller::updateNewSupplierName,
                    label = stringResource(Res.string.operational_supplier_new_placeholder),
                    modifier = Modifier.fillMaxWidth(),
                )
                AppButton(
                    text = stringResource(Res.string.operational_supplier_use_existing),
                    onClick = controller::useExistingSupplier,
                    variant = PortalButtonVariant.Text,
                )
            }
        }
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween,
        ) {
            Text(
                text = stringResource(Res.string.operational_supplier_installment),
                style = MaterialTheme.typography.bodyMedium,
            )
            Switch(
                checked = controller.supplierDialogInstallment,
                onCheckedChange = controller::updateInstallmentEnabled,
            )
        }
        if (controller.supplierDialogInstallment) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
            ) {
                AppTextField(
                    value = controller.supplierDialogInstallments,
                    onValueChange = controller::updateInstallments,
                    label = stringResource(Res.string.operational_supplier_installments),
                    modifier = Modifier.weight(1f),
                )
                AppTextField(
                    value = controller.supplierDialogCurrent,
                    onValueChange = controller::updateCurrentInstallment,
                    label = stringResource(Res.string.operational_supplier_current),
                    modifier = Modifier.weight(1f),
                )
            }
        }
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.operational_cancel),
                onClick = controller::dismissSupplierDialog,
                variant = PortalButtonVariant.Text,
            )
            AppButton(
                text =
                    when {
                        controller.supplierDialogMode == SupplierDialogMode.NEW -> stringResource(Res.string.operational_supplier_add)
                        controller.supplierDialogIsEdit -> stringResource(Res.string.operational_action_save)
                        else -> stringResource(Res.string.operational_supplier_select_confirm)
                    },
                onClick = controller::confirmSupplierDialog,
                enabled = controller.canConfirmSupplier,
            )
        }
    }
}

@Composable
private fun RemoveSupplierDialog(controller: OperationalEntriesController) {
    AppModalCard(
        title = stringResource(Res.string.operational_supplier_remove_title),
        onDismiss = controller::dismissRemoveSupplier,
    ) {
        Text(
            text = stringResource(Res.string.operational_supplier_remove_message),
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.operational_cancel),
                onClick = controller::dismissRemoveSupplier,
                variant = PortalButtonVariant.Text,
            )
            AppButton(
                text = stringResource(Res.string.operational_supplier_remove_confirm),
                onClick = controller::confirmRemoveSupplier,
            )
        }
    }
}

@Composable
private fun LoadingBox() {
    Box(
        modifier = Modifier.fillMaxWidth().height(240.dp),
        contentAlignment = Alignment.Center,
    ) {
        CircularProgressIndicator()
    }
}

@Composable
private fun UnderConstructionContent(title: String) {
    Text(
        text = title,
        style = MaterialTheme.typography.headlineMedium,
    )
    Box(
        modifier = Modifier.fillMaxWidth().height(240.dp),
        contentAlignment = Alignment.Center,
    ) {
        Text(
            text = stringResource(Res.string.operational_under_construction),
            style = MaterialTheme.typography.titleLarge,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
    }
}

@Composable
private fun OperationalEntryStatus.label(): String =
    when (this) {
        OperationalEntryStatus.DRAFT -> stringResource(Res.string.operational_status_draft)
        OperationalEntryStatus.SUBMITTED -> stringResource(Res.string.operational_status_submitted)
        OperationalEntryStatus.APPROVED -> stringResource(Res.string.operational_status_approved)
        OperationalEntryStatus.REJECTED -> stringResource(Res.string.operational_status_rejected)
    }

private fun OperationalEntryStatus.badgeColors(): Pair<Color, Color> =
    when (this) {
        OperationalEntryStatus.DRAFT -> AppPalette.Neutral200 to AppPalette.Neutral900
        OperationalEntryStatus.SUBMITTED -> AppPalette.Warning100 to AppPalette.Warning900
        OperationalEntryStatus.APPROVED -> AppPalette.Success100 to AppPalette.Success900
        OperationalEntryStatus.REJECTED -> AppPalette.Error100 to AppPalette.Error900
    }
